import React, { useCallback, useContext } from "react";

import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import RetailDealersGrid from "./views/RetailDealersGrid";
import AddRetailDealerForm from "./forms/AddRetailDealerForm";
import { contextApiActions } from "../../../../_redux/_constants/common.constants";
import { Context } from "../../../../_context/Store";

export default function RetailDealersWrapper() {
     const [, contextDispatch] = useContext(Context);

     const closeModal = useCallback(() => {
          contextDispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: { show: false },
          });
     }, [contextDispatch]);

     const openAddDealer = useCallback(() => {
          contextDispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Add a dealer",
                    children: <AddRetailDealerForm onSaved={closeModal} />,
               },
          });
     }, [contextDispatch, closeModal]);

     return (
          <>
               <MainLeftTitle title="Dealers" />

               <RetailDealersGrid onAddDealer={openAddDealer} />
          </>
     );
}
